import { FunctionComponent, memo } from 'react';
import { IconLabel } from '../IconLabel';

import classNames from 'classnames';
import classes from './CloseButton.module.scss';

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel: string;
  backgroundColor?: string;
  iconBackgroundColor?: string;
  disabled?: boolean;
  className?: string;
}

export const CloseButton: FunctionComponent<CloseButtonProps> = memo(
  ({ onClick, ariaLabel, backgroundColor, iconBackgroundColor, disabled, className }) => {
    return (
      <button
        type={'button'}
        className={classNames(classes['close'], className, {
          [classes['close--disabled']]: disabled,
        })}
        style={{ backgroundColor }}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
      >
        <IconLabel
          className={classes['close__icon']}
          iconId={'close'}
          iconSize={20}
          color={iconBackgroundColor ?? '#fff'}
          singleColor
        />
      </button>
    );
  }
);
